<div class="country-icon" *ngIf="country">
  <span>{{ country.code }}</span>
</div>

<select #select *ngIf="phoneCodeList.length" [ngModel]="prefix" (ngModelChange)="onPhonePrefixChange($event)">
  <option [value]="phoneCode" *ngFor="let phoneCode of phoneCodeList">+{{ phoneCode }}</option>
</select>

<input #input type="text" [id]="id" [ngModel]="phone" (ngModelChange)="onPhoneValueChange($event)" placeholder="80xxxxxxxx">
